"use client";

const SizeSelector = ({ selected, sizes = [], handleSizeSelection }) => {
  return (
    <div className="flex flex-wrap gap-3 py-3">
      {sizes.map((item) => {
        if (!item.size) return null;
        const isSelected = selected === item.id;
        return (
          <label
            key={`${item.sku}_${item.size}`}
            className={`flex px-2 items-center justify-center text-subtitle-4-b transition-colors duration-300 rounded cursor-pointer border min-w-[36px] h-[36px]
            ${
              isSelected
                ? "bg-primary-blue text-tertiary-white border-primary-blue"
                : "bg-white text-primary-black-600 border-primary-black-100"
            }`}
          >
            <input
              type="radio"
              name="liters"
              value={item.size}
              className="hidden"
              defaultChecked={isSelected}
              onChange={() => handleSizeSelection(item.id)}
            />
            {item.size}
          </label>
        );
      })}
    </div>
  );
};

export default SizeSelector;
